/**
 *
 * DownloadResults
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { StyledDownloadResults } from './styledComponents';
import resultsIcon from '../../assets/icons/results.png';
import docIcon from '../../assets/icons/doc.svg';

interface IProps {
  url: string;
}

const DownloadResults: FunctionComponent<IProps> = ({ url }) => {
  return (
    <StyledDownloadResults>
      <div className="d-flex w-100 flex-column align-items-center mt-50">
        <img src={resultsIcon} className=" mb-19" alt="" />

        <a
          href={url}
          download={url.substring(url.lastIndexOf('/') + 1)}
          className="txt fs-20 fw-7 txt-accent mb-10 text-center"
        >
          Download Results <img src={docIcon} alt="" />
        </a>
        <div className="txt txt-secondary text-center">
          Please download a file with Results.
        </div>
      </div>
    </StyledDownloadResults>
  );
};

export default memo(DownloadResults);
